import { render } from "./NoBackend.vue?vue&type=template&id=f4e06c3c"
import script from "./NoBackend.vue?vue&type=script&lang=js"
export * from "./NoBackend.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__